/**
 * Font chữ
 */
export default {
  TimesNewRoman: 'TimesNewRoman',
  OpenSan: 'OpenSan',
  Arial: 'Arial',
  Tahoma: 'Tahoma',
  Cambria: 'Cambria',
  ArialNarrow: 'ArialNarrow',
};
